import store from '@/store/indexStore';
import axios from '@/composable/axios';
import { handleAxiosCommonException } from '@/composable/common';

/**
 * @vuese
 * ユーザ情報の取得処理
 */
export async function fetchUserInformation() {
  const GetUserInformationParameters = new URLSearchParams();
  GetUserInformationParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/user', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetUserInformationParameters,
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return {};
    });
  return axiosResult;
}

/**
 * モニター情報の取得処理
 */
export async function fetchMonitorInformation() {
  const GetMonitorInformationParameters = new URLSearchParams();
  GetMonitorInformationParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/monitor', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetMonitorInformationParameters,
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return {};
    });
  return axiosResult;
}

/**
 * @vuese
 * 素材一覧の取得処理
 */
export async function dataFetchMaterials() {
  const GetMaterialParameters = new URLSearchParams();
  GetMaterialParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/material', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetMaterialParameters,
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * アップロード中の素材数取得処理
 */
export async function dataFetchUploadingMaterialNum() {
  const GetMaterialParameters = new URLSearchParams();
  GetMaterialParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/material/uploading', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetMaterialParameters,
    })
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
  return axiosResult;
}

/**
 * アップロード中の素材情報を取得する
 */
export async function fetchPendingMaterialList(materialUrlList) {
  const GetMaterialParameters = new URLSearchParams();
  GetMaterialParameters.append('userId', store.getters['userInformation/getUserId']);
  GetMaterialParameters.append('materialUrlList', materialUrlList);
  const axiosResult = await axios
    .get('/material/uploading', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetMaterialParameters,
    })
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * コンテンツ一覧の取得処理
 */
export async function dataFetchContents() {
  const GetContentsParameters = new URLSearchParams();
  GetContentsParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/content', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetContentsParameters,
    })
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * 配信グループ一覧の取得処理
 */
export async function dataFetchStreamGroups() {
  const GetStreamGroupParameters = new URLSearchParams();
  GetStreamGroupParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/streamgroup', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetStreamGroupParameters,
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * コンテンツ詳細情報取得処理
 */
export async function dataFetchContentDetail(contentId) {
  const GetContentDetailParameters = new URLSearchParams();
  GetContentDetailParameters.append('contentId', contentId);
  GetContentDetailParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/content/detail', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetContentDetailParameters,
    })
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * 配信グループ詳細情報取得処理
 */
export async function dataFetchStreamGroupDetail() {
  const GetStreamGroupDetailParameters = new URLSearchParams();
  GetStreamGroupDetailParameters.append(
    'streamGroupId',
    store.getters['streamGroup/getStreamGroupId']
  );
  GetStreamGroupDetailParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/streamgroup/detail', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetStreamGroupDetailParameters,
    })
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * 配信グループ登録ステータス取得処理
 * @returns
 */
export async function dataFetchUpdateStatus() {
  const GetStreamGroupUpdateStatusParameters = new URLSearchParams();
  GetStreamGroupUpdateStatusParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/streamgroup/isupdating', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetStreamGroupUpdateStatusParameters,
    })
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * コンテンツフレーム一覧の取得処理
 */
export async function dataFetchContentFrames() {
  const GetContentFramesParameters = new URLSearchParams();
  GetContentFramesParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/content/frame/all', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetContentFramesParameters,
    })
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * コンテンツフレーム一覧の取得処理
 */
export async function dataFetchContentFramesHistory() {
  const GetContentFramesParameters = new URLSearchParams();
  GetContentFramesParameters.append('userId', store.getters['userInformation/getUserId']);
  const axiosResult = await axios
    .get('/content/frame/history', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: GetContentFramesParameters,
    })
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}

/**
 * @vuese
 * お知らせの取得処理
 */
export async function dataFetchNotice() {
  const axiosResult = await axios
    .get('/notice')
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((error) => {
      // 共通例外処理をCall
      handleAxiosCommonException(error);
      return [];
    });
  return axiosResult;
}
